var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCharacterCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1779 3.02902C12.4726 3.12726 12.6319 3.44581 12.5336 3.74053L10.9054 8.62515H15.3446L17.0914 3.38477C17.1896 3.09006 17.5082 2.93078 17.8029 3.02902C18.0976 3.12726 18.2569 3.44581 18.1586 3.74053L16.5304 8.62515H20.4375C20.7482 8.62515 21 8.87699 21 9.18765C21 9.49831 20.7482 9.75015 20.4375 9.75015H16.1554L14.2804 15.3752H18.1875C18.4982 15.3752 18.75 15.627 18.75 15.9377C18.75 16.2483 18.4982 16.5002 18.1875 16.5002H13.9054L12.5336 20.6155C12.4354 20.9102 12.1168 21.0695 11.8221 20.9713C11.5274 20.873 11.3681 20.5545 11.4664 20.2598L12.7196 16.5002H8.28043L6.90863 20.6155C6.8104 20.9102 6.49184 21.0695 6.19712 20.9713C5.9024 20.873 5.74313 20.5545 5.84137 20.2598L7.09457 16.5002H3.5625C3.25184 16.5002 3 16.2483 3 15.9377C3 15.627 3.25184 15.3752 3.5625 15.3752H7.46957L9.34457 9.75015H5.8125C5.50184 9.75015 5.25 9.49831 5.25 9.18765C5.25 8.87699 5.50184 8.62515 5.8125 8.62515H9.71957L11.4664 3.38477C11.5646 3.09006 11.8832 2.93078 12.1779 3.02902ZM10.5304 9.75015L8.65543 15.3752H13.0946L14.9696 9.75015H10.5304Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCharacterCount);
export default __webpack_public_path__ + "static/media/icon_character-count.cfa9e21ab33e127737480bd3096b828c.svg";
export { ForwardRef as ReactComponent };